<template>
  <div class="IndustryStatistics">
    <div
      class="operations-head-content"
      style="width: 100%; align-items: center"
    >
      <h2 id="gf7b16" class="operations-head">
        {{ $t("ContentTabs.IndustryStatistics") }}
      </h2>
      <div>
        <el-select
          v-model="SelectYear"
          placeholder="Select a Year"
          @change="selectYears"
          class="year_select"
        >
          <el-option
            v-for="item in YeraOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="cop_cont_box">
      <div class="cop_cont_cont flex_box">
        <div class="list title list-title">
          <div class="item item_active"></div>
          <div class="item">{{ $t("IndustryStatistics.Industry") }}</div>
          <div class="item">{{ $t("IndustryStatistics.CompanyType") }}</div>
          <div class="item">{{ $t("IndustryStatistics.CompanySize") }}</div>
          <div class="item">{{ $t("IndustryStatistics.CompanyStatus") }}</div>
          <div class="item">{{ $t("IndustryStatistics.YearsinBusiness") }}</div>
          <div class="item">{{ $t("IndustryStatistics.CompanyRating") }}</div>
        </div>
        <div class="list content list contentone">
          <div class="item item_active">
            <div>
              {{ $t("IndustryStatistics.SubjectCompany") }}
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.Industry }}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ compObj.CompanyType }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.CompanySize }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.companyStatus }}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ compObj.YearsinBusiness }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.CompanyRating }}</div>
          </div>

          <!-- <div class="item" v-show="lastView || lastView3"></div> -->
        </div>
        <div class="list content list contentone">
          <div class="item item_active">
            <div>
              {{ $t("IndustryStatistics.Country") }}:
              {{ getCountry($route.query.companyCountry) }}
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ sameIndustry.Industry | FilterNum}}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ sameIndustry.CompanyType | FilterNum }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ sameIndustry.CompanySize | FilterNum }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ sameIndustry.companyStatus | FilterNum }}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ sameIndustry.YearsinBusiness | FilterNum}}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ sameIndustry.CompanyRating | FilterNum}}</div>
          </div>
          <!-- <div class="item" v-show="lastView || lastView3"></div> -->
        </div>
        <div class="list content">
          <div class="item item_active">
            <div
              class="flex_center"
              v-show="!isDelOne"
              style="flex: none"
              @click="(addIndex = 2), delCompany()"
            >
              <!-- <i class="cop_del_ic"></i> -->
              {{ getCountry(indexTwoCountrycode) }}
              <svg
                t="1730875902586"
                style="margin-left: 10px"
                class="icon icon-height"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6280"
              >
                <path
                  d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                  fill="#F56B6B"
                  p-id="6281"
                ></path>
              </svg>
            </div>
            <div class="cop_add">
              <div
                class="flex_center CompanyNameActive"
                v-show="isDelOne"
                @click="(addIndex = 2), Add()"
              >
                <!-- <i class="cop_add_ic"></i> -->
                <span
                  v-if="!isDelOneSelect"
                  class="flex_center"
                  @click="isDelOneSelect = true"
                >
                  <svg
                    t="1725586885335"
                    class="icon icon-height"
                    style="margin-right: 10px"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5401"
                  >
                    <path
                      d="M995.84 483.84H540.16V28.16a28.16 28.16 0 1 0-56.32 0v455.68H28.16a28.16 28.16 0 0 0 0 56.32h455.68v455.68a28.16 28.16 0 1 0 56.32 0V540.16h455.68a28.16 28.16 0 1 0 0-56.32z"
                      p-id="5402"
                      fill="#1290C9"
                    ></path>
                  </svg>
                  {{ $t("IndustryStatistics.Compare") }}
                </span>
                <el-select
                  v-else
                  filterable
                  v-model="indexTwoCountrycode"
                  :placeholder="$t('IndustryStatistics.SearchCountry')"
                  @change="changeCountry"
                  clearable
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.countryCode"
                    :label="item.nameEn"
                    :value="item.countryCode"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustry?.Industry | FilterNum}}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ queryIndustry?.CompanyType | FilterNum}}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustry?.CompanySize | FilterNum }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustry?.companyStatus | FilterNum }}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ queryIndustry?.YearsinBusiness | FilterNum }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustry?.CompanyRating | FilterNum}}</div>
          </div>
        </div>
        <div class="list content">
          <div class="item item_active">
            <div
              class="flex_center"
              v-show="!isDelTwo"
              style="flex: none"
              @click="(addIndex = 3), delCompany()"
            >
              <!-- <i class="cop_del_ic"></i> -->
              {{ getCountry(indexTreeCountrycode) }}
              <svg
                t="1730875902586"
                style="margin-left: 10px"
                class="icon icon-height"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6280"
              >
                <path
                  d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                  fill="#F56B6B"
                  p-id="6281"
                ></path>
              </svg>
            </div>
            <div class="cop_add">
              <div
                class="flex_center CompanyNameActive"
                v-show="isDelTwo"
                @click="(addIndex = 3), Add()"
              >
                <span
                  v-if="!isDelTwoSelect"
                  class="flex_center"
                  @click="isDelTwoSelect = true"
                >
                  <svg
                    t="1725586885335"
                    class="icon icon-height"
                    style="margin-right: 10px"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5401"
                  >
                    <path
                      d="M995.84 483.84H540.16V28.16a28.16 28.16 0 1 0-56.32 0v455.68H28.16a28.16 28.16 0 0 0 0 56.32h455.68v455.68a28.16 28.16 0 1 0 56.32 0V540.16h455.68a28.16 28.16 0 1 0 0-56.32z"
                      p-id="5402"
                      fill="#1290C9"
                    ></path>
                  </svg>
                  {{ $t("IndustryStatistics.Compare") }}
                </span>
                <el-select
                  v-else
                  filterable
                  v-model="indexTreeCountrycode"
                  :placeholder="$t('IndustryStatistics.SearchCountry')"
                  @change="changeCountryTwo"
                  clearable
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.countryCode"
                    :label="item.nameEn"
                    :value="item.countryCode"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustrytwo?.Industry }}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ queryIndustrytwo?.CompanyType | FilterNum}}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustrytwo?.CompanySize | FilterNum}}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustrytwo?.companyStatus | FilterNum }}</div>
          </div>

          <div class="item">
            <div class="line_2">{{ queryIndustrytwo?.YearsinBusiness | FilterNum}}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ queryIndustrytwo?.CompanyRating | FilterNum}}</div>
          </div>
        </div>
      </div>
    </div>

    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import {
  getCompanyIndustry,
  getDynamicsCompanyIndustry,
  getBlockListData,
} from "@/api/companyApi.js";

import { mixins1 } from "@/mixins/index";

import ReLogin from "@/components/ReLogin.vue";

export default {
  mixins: [mixins1],
  // components: { Page },
  components: {
    ReLogin,
  },

  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getBlockListData();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      reLoginVis: false,
      indexTwoCountrycode: "",
      indexTreeCountrycode: "",
      SelectYear: 2023,
      YeraOptions: [],
      compObj: {
        Industry: "",
        CompanyType: "",
        CompanyLegalStatus: "",
        CompanySize: "",
        CompanyStatus: "",
        YearsinBusiness: "",
        CompanyRating: "",
      },
      sameIndustry: {},
      addIndex: 1,
      lastView: false,
      lastView3: false,
      isDelOne: true,
      isDelTwo: true,
      isDelOneSelect: false,
      isDelTwoSelect: false,

      queryIndustry: null,
      queryIndustrytwo: null,

      //国家分类
      countryCode: "",
      countryOptions: [],
      industryCode: "",
    };
  },
  computed: {
    //index传值 是否翻译
  },

  created() {
    this.getYearList();
    this.getCountryList();
  },
  methods: {
    selectYears() {
      this.queryIndustrytwo = null;
      this.queryIndustry = null;

      this.getData();
      this.addIndex = 1;
      this.isDelOne = true;
      this.isDelOneSelect = false;
      this.lastView = false;
      this.isDelTwo = true;
      this.lastView3 = false;
      this.isDelTwoSelect = false;
      this.indexTwoCountrycode = "";
      this.indexTreeCountrycode = "";
    },
    getYearList() {
      getCompanyIndustry({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.YeraOptions = res.data.yearFilter;
          this.SelectYear = this.YeraOptions[0].id;
          this.industryCode = res.data.isicCode;
          this.getData();
          this.getBlockListData();
        }
      });
    },
    getBlockListData() {
      getBlockListData({
        reportYear: this.SelectYear,
        industryCode: this.industryCode,
        countryCode: this.$route.query.companyCountry,
      }).then((res) => {
        if (res.code == 200) {
          let manManagementSummary = [
            {
              name: this.$t("IndustryStatistics.Country"),
              id: this.$t("IndustryStatistics.Country"),
              num: res.data.country,
            },
            {
              name: this.$t("IndustryStatistics.Industry"),
              id: this.$t("IndustryStatistics.Industry"),
              num: res.data.industry,
            },
            {
              name: this.$t("IndustryStatistics.CompanySize"),
              id: this.$t("IndustryStatistics.CompanySize"),
              num: res.data.size,
            },
            {
              name: this.$t("IndustryStatistics.Liquidity"),
              id: this.$t("IndustryStatistics.Liquidity"),
              num: res.data.liquidity,
            },
            {
              name: this.$t("IndustryStatistics.NoofcoinIndustry"),
              id: this.$t("IndustryStatistics.NoofcoinIndustry"),
              num: res.data.numberOfIndustry,
            },
            {
              name: this.$t("IndustryStatistics.IndustryRating"),
              id: this.$t("IndustryStatistics.IndustryRating"),
              num: res.data.industryRating,
            },
            {
              name: this.$t("IndustryStatistics.Profitability"),
              id: this.$t("IndustryStatistics.Profitability"),
              num: res.data.profitability,
            },
            {
              name: this.$t("IndustryStatistics.Growth"),
              id: this.$t("IndustryStatistics.Growth"),
              num: res.data.growth,
            },
            {
              name: this.$t("IndustryStatistics.FinancialStructurt"),
              id: this.$t("IndustryStatistics.FinancialStructurt"),
              num: res.data.financialStructurt,
            },
            {
              name: this.$t("IndustryStatistics.Solvency"),
              id: this.$t("IndustryStatistics.Solvency"),
              num: res.data.repaying,
            },
          ];
          this.$emit("UpdatamarkTotalList", manManagementSummary);
        } else {
          this.$emit("UpdatamarkTotalList", []);
        }
      });
    },
    getCountryList() {
      this.countryOptions = JSON.parse(
        localStorage.getItem("countryList"),
      )[0].countryList;
    },

    changeCountry() {
      this.getData(this.indexTwoCountrycode);
    },
    changeCountryTwo() {
      this.getData(this.indexTreeCountrycode);
    },

    // 选中国家

    async getData(Country) {
      getDynamicsCompanyIndustry({
        countryCode: this.$route.query.companyCountry,
        id3a: this.$route.query.id3a,
        queryCountryCode: Country,
        queryYear: this.SelectYear,
      })
        .then((resdata) => {
          if (resdata.code == 200) {
            let res = resdata.data;
            this.compObj = {
              Industry: res.subjectCompany.industry,
              CompanyType: res.subjectCompany.type,
              YearsinBusiness: res.subjectCompany.years,
              CompanySize: res.subjectCompany.scale,
              CompanyRating: res.subjectCompany.rating,
              companyStatus: res.subjectCompany.companyStatus,
            };
            this.sameIndustry = {
              Industry: res.sameIndustry.industry,
              CompanyType: res.sameIndustry.type,
              YearsinBusiness: res.sameIndustry.years,
              CompanySize: res.sameIndustry.scale,
              CompanyRating: res.sameIndustry.rating,
              companyStatus: res.sameIndustry.companyStatus,
            };
            if (this.addIndex == 2) {
              this.queryIndustry = {
                Industry: res.queryIndustry.industry,
                CompanyType: res.queryIndustry.type,
                YearsinBusiness: res.queryIndustry.years,
                CompanySize: res.queryIndustry.scale,
                CompanyRating: res.queryIndustry.rating,
                companyStatus: res.queryIndustry.companyStatus,
              };
              this.isDelOne = false;
              this.lastView = true;
            }
            if (this.addIndex == 3) {
              this.queryIndustrytwo = {
                Industry: res.queryIndustry.industry,
                CompanyType: res.queryIndustry.type,
                YearsinBusiness: res.queryIndustry.years,
                CompanySize: res.queryIndustry.scale,
                CompanyRating: res.queryIndustry.rating,
                companyStatus: res.queryIndustry.companyStatus,
              };
              this.isDelTwo = false;
              this.lastView3 = true;
            }
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },

    //add compant弹框
    Add() {},

    //删除添加
    delCompany() {
      if (this.addIndex == 2) {
        this.queryIndustry = {};
        this.indexTwoCountrycode = "";
        this.isDelOne = true;
        this.isDelOneSelect = false;
        this.lastView = false;
      } else {
        this.queryIndustrytwo = {};
        this.indexTreeCountrycode = "";
        this.isDelTwo = true;
        this.lastView3 = false;
        this.isDelTwoSelect = false;
      }
    },
  },
};
</script>
<style scoped lang="less">

.operations-head{
  color: #1290c9;
}

.sel_coun {
  position: relative;
}

.el-select,
.el-autocomplete {
  width: 100%;
}

.cop_title {
  display: flex;
  align-items: center;
  font-size: 1.4285714285714286rem;
  font-family: "Arial Bold";
  margin-bottom: 2.142857142857143rem;
  margin-top: 0.7142857142857143rem;
}

.icon-height {
  height: 20px;
}

.cop_add {
  // width: 18.857142857142858rem;
  // width: 25%;
  height: 20px;
  cursor: pointer;
  width: 100%;
}

.cop_add .flex_center {
  height: 20px;
  font-size: 18px;
}

.cop_add_ic {
  background: #1290c9;
  // background-image: url(../../assets/img/detail/add_ic.png);
}

.cop_del_ic {
  background: #f56b6b;
  // background-image: url(../../assets/img/detail/del_ic.png);
}

.cop_del_ic,
.cop_add_ic {
  width: 1.5714285714285714rem;
  height: 1.5714285714285714rem;
  background-repeat: no-repeat;
  background-size: 0.7142857142857143rem;
  background-position: center;
  border-radius: 50%;
  margin-right: 0.5714285714285714rem;
}

.cop_cont_box {
  position: relative;
  background: #ffffff;
  // padding-top: 2.857142857142857rem;
}

.cop_cont_cont .item {
  display: flex;
  align-items: center;
  padding: 11px;
  font-size: 18px;
  height: 80px;
  // line-height: 58px;
  border-bottom: 1px solid #cccccc;
  // border-right: 1px solid #e7eaed;
}

.list-title .item {
  background: #f2f5f9;
}

.item_active {
  border-right: none !important;
}
.item_active div,
.CompanyNameActive span,
.list-title .item {
  font-family: "Arial Bold";
}
.cop_cont_cont .list.title .item {
  // width: 20rem;
  overflow: hidden;
  padding: 0.5714285714285714rem 1.4285714285714286rem;
  color: #1a2332;
}

.cop_cont_cont .list.content {
  // width: 21.428571428571427rem;
  width: 27%;
  // border-left: 0.07142857142857142rem solid #e7eaed;
}

.cop_cont_cont .list.content.last {
  width: 19rem;
}

.line_2 .c_d_tag {
  width: 17.5rem;
}

.line_2 {
}

.list-title {
  width: 25%;
}

.CompanyNameActive {
  font-size: 1.2857142857142858rem;
  color: #1290c9;
  text-decoration-line: underline;
}

::v-deep .el-input--suffix {
  right: 0px !important;
  top: 0px !important;
  height: 48px;
  position: relative;
}
::v-deep .el-input__inner {
  position: absolute;
  top: 0px !important;
}

.content {
  padding: 0rem;
  margin: 0rem !important;
}

.flex_center {
  justify-content: flex-start;
}

.item_active {
  background: #f2f5f9;
  height: 50px !important;
  position: relative;
}

.IndustryStatistics {
  box-shadow: 0px 0.14rem 0.28rem 0px rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 0.28rem;
  padding: 2.142857142857143rem 2.85714285714285rem;
}

.operations-content {
  padding: 2.142857142857143rem 2.857142857142857rem;
  background: #ffffff;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.2857142857142857rem;
}
.contentRight .item,
.contentRight .CompanyNameActive,
.Deletepostion {
  justify-content: end;
  width: 100%;
}
.Deletepostion,
.CompanyNameActive {
  width: 100%;
}
.year_select {
  width: 280px;
  height: 50px;
}

@media (max-width: 1920px) {
  .cop_cont_cont .item {
    padding: 8px;
    font-size: 16px;
    height: 50px;
    // line-height: 44px;
  }
  .item_active {
    height: 44px !important;
  }
  .cop_add {
    height: 16px;
  }
  .cop_add .flex_center {
    height: 16px;
    font-size: 16px;
  }
  ::v-deep .el-input--suffix {
    height: 36px;
  }
  .icon-height {
    height: 16px;
  }
  .year_select {
    width: 210px;
    height: 38px;
  }
}

@media (max-width: 1439px) {
  .cop_cont_cont .item {
    padding: 7px;
    font-size: 14px;
    height: 54px;
    // line-height: 40px;
  }
  .item_active {
    height: 34px !important;
  }
  .cop_add {
    height: 14px;
  }
  .cop_add .flex_center {
    height: 14px;
    font-size: 14px;
  }
  ::v-deep .el-input--suffix {
    height: 32px;
  }
  .icon-height {
    height: 14px;
  }
}
.year_select {
  width: 188px;
  height: 34px;
}
</style>
